var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23928 2.3416C7.47928 1.6048 8.52168 1.6048 8.76088 2.3416L9.61688 4.9752C9.66917 5.13559 9.77084 5.27535 9.90733 5.37449C10.0438 5.47362 10.2082 5.52708 10.3769 5.5272H13.1465C13.9217 5.5272 14.2433 6.5192 13.6169 6.9752L11.3769 8.6024C11.2401 8.70163 11.1383 8.84161 11.0859 9.00228C11.0336 9.16296 11.0335 9.33607 11.0857 9.4968L11.9417 12.1304C12.1817 12.8672 11.3377 13.4808 10.7097 13.0248L8.46968 11.3976C8.33304 11.2984 8.16852 11.245 7.99968 11.245C7.83083 11.245 7.66631 11.2984 7.52968 11.3976L5.28968 13.0248C4.66248 13.4808 3.81928 12.8672 4.05848 12.1304L4.91448 9.4968C4.96662 9.33607 4.96652 9.16296 4.91421 9.00228C4.8619 8.84161 4.76005 8.70163 4.62328 8.6024L2.38408 6.976C1.75768 6.52 2.08008 5.528 2.85448 5.528H5.62328C5.79211 5.52805 5.95664 5.47467 6.0933 5.37552C6.22995 5.27637 6.33174 5.13652 6.38408 4.976L7.24008 2.3424L7.23928 2.3416Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.36b6751302b7339fa43e43074e141474.svg";
export { ForwardRef as ReactComponent };